module.exports = __webpack_public_path__ + "f572638f/img/share-action-icon.9c12578c.svg";